import React, { useEffect, useState } from 'react';
import { WithToggleButton } from '@components/design/WithToggleButton';
import { WithExportButton } from '@components/design/WithExportButton';
import { actions, elements } from '@ecosystem/newron-design-system';
import { getToggleViewConfig, IconMapping } from '@components/toggle-view-buttons/ToggleViewButtonConfig';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { ViewType } from '@hooks/export/Model';
import { useLocation } from 'react-router-dom';

interface ToggleViewButtonProps {
  isExportDisabled: boolean;
  onExportClick: () => void;
  view: ViewType;
  onChange: (value: ViewType) => void;
}

const { ToggleButtons } = actions;
const { Icon } = elements;

export const ToggleViewButtons: React.FC<ToggleViewButtonProps> = ({
  isExportDisabled,
  onExportClick,
  view,
  onChange,
}) => {
  const { pageType } = usePageConfig();
  const { pathname } = useLocation();

  const { options, defaultView } = getToggleViewConfig(pageType, pathname);

  const [selectedValue, setSelectedValue] = useState(view ?? defaultView);

  const handleChange = (value: ViewType | string) => {
    setSelectedValue(value as ViewType);
    if (selectedValue !== value) onChange(value as ViewType);
  };
  useEffect(() => {
    if (view) {
      setSelectedValue(view);
    }
  }, [view]);

  const filteredOptions = options.filter((option: string | number) => IconMapping[option]);

  return (
    <div className="flex">
      <WithExportButton disabled={isExportDisabled} onClick={onExportClick} />
      <span className="pl-4" key={selectedValue}>
        <WithToggleButton value={view} onChange={handleChange}>
          {filteredOptions.map((option) => (
            <ToggleButtons.Option key={option} id={option} testId={option}>
              <Icon>{IconMapping[option] as React.ReactElement}</Icon>
            </ToggleButtons.Option>
          ))}
        </WithToggleButton>
      </span>
    </div>
  );
};
